import { render, staticRenderFns } from "./PortalOrders.vue?vue&type=template&id=6ae43aad"
import script from "./PortalOrders.vue?vue&type=script&lang=js"
export * from "./PortalOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports